import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsTheme from "../../sps/chartsTheme";
import { useSelector } from "react-redux";
import { getTheme } from "../highChartTheme";


// Highcharts.setOptions(HighchartsTheme.dark);


const ColumnChart = (props: any) => {
  const [missReason, setMissReason] = useState([]);
  const [missFrequency, setMissFrequency] = useState([]);
  const [colorCode, setColorCode] = useState([]);
  let isLightMode = useSelector((state: any) => state.theme.lightMode);
 
  //let barCount=0;
  // const [sDate, setSDate] = useState(new Date());
  // const [eDate, setEDate] = useState(new Date());
  // const [duration, setDuration] = useState(60);
  useEffect(() => {
    if (props.dleMissReasonParetoData) {
      let missReasonData = props.dleMissReasonParetoData?.map((x: any) => {
        return [x.reasonCode, parseInt(x.frequency)]
      });
      let missReasonColorData = props.dleMissReasonParetoData?.map((x: any) => {
        return [x.colorCode]
      });
      setMissReason(missReasonData?.map(([reasonCode]: any) => reasonCode));
      setMissFrequency(missReasonData?.map(([frequency]: any) => frequency));
      setColorCode(missReasonColorData?.map(([colorCode]: any) => colorCode));
    }
  }, [props.dleMissReasonParetoData])
  const options = {
    chart: {
      type: "column",
    },
    tooltip: {
      shared: true,
    },
    series: [
      {
        showInLegend: false,
        name: '',
        type: "column",
        colorByPoint: true,
        colors: colorCode,
        data: props.dleMissReasonParetoData?.map((x: any) => {
          return [x.reasonCode, parseInt(x.frequency)]
        }),
      },
    ],
  };

  return props.dleMissReasonParetoData && missReason &&
    <HighchartsReact
      highcharts={Highcharts}
      options={
        {
          ...options,
          ...getTheme("DLE Reason For Miss - Pareto Chart", isLightMode, missReason),
        }
      }
    />
}
export default ColumnChart;